import * as React from 'react';

const Logger = (props: any) => <div className="example-config">
    <h5>{props.title}</h5>
    <ul className="event-log">
        {props.events.reverse().map((event: any, idx: any) => <li key={idx}>{event}</li>)}
    </ul>
</div>;

export {Logger};